import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { meta } from '../../../styles/visualLanguage';

/** A quiet warning marker; the message carries the meaning without relying on color. */
export function AdvisoryReviewWarning({
  children,
  testId,
}: {
  children: React.ReactNode;
  testId?: string;
}) {
  return (
    <Box data-testid={testId} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mt: 1.5 }}>
      <Box
        component="span"
        aria-hidden="true"
        data-testid="advisory-review-warning-dot"
        sx={theme => ({
          width: 6,
          height: 6,
          flexShrink: 0,
          marginTop: '8px',
          borderRadius: '50%',
          backgroundColor: theme.colors.reviewWarning,
          boxShadow: `0 0 0 3px ${alpha(theme.colors.reviewWarning, 0.1)}, 0 0 9px 2px ${alpha(
            theme.colors.reviewWarning,
            0.24
          )}`,
        })}
      />
      <Typography sx={[meta]}>{children}</Typography>
    </Box>
  );
}
